import { render, staticRenderFns } from "./CreateDelivery.vue?vue&type=template&id=041b4ea2&scoped=true"
import script from "./CreateDelivery.vue?vue&type=script&lang=js"
export * from "./CreateDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041b4ea2",
  null
  
)

export default component.exports